import bsCollapse from 'bootstrap/js/dist/collapse';

export default {
  install: (app, options) => {
    const collapses = [];

    const show = (id, options = { toggle: false }, callback_route) => {
      document.querySelectorAll('[data-bs-toggle-controls]').forEach(controller => {
        controller.classList.add('collapsed');
      });

      const collapseEl = document.getElementById(id);
      const collapseIndex = collapses.findIndex(element => element.id == id);

      if (collapseIndex === -1) {
        const collpaseObject = new bsCollapse(collapseEl, options);

        collapses.push({
          'id': id,
          'object': collpaseObject
        });

        collpaseObject.show();
      } else {
        collapses[collapseIndex].object.show();
      }

      document.querySelector(`[data-bs-toggle-controls=${id}]`).classList.remove('collapsed');
    };

    const hide = id => {
      const collapseIndex = collapses.findIndex(element => element.id == id);
      collapses[collapseIndex].object.hide();
    }

    const collapse = { show, hide };
    app.config.globalProperties.$collapse = collapse;
    app.provide('$collapse', collapse);
  }
}